import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { UserDetailInterface } from '../interfaces/user-detail.interface'
import { WebSettingsInterface } from '@modules/user-module/interfaces/web-settings.interface'
import { DeviceIdLocalStorageKeyConst } from '@modules/user-module/constants/device-id-local-storage-key.const'
import { UtilsService } from '@shared/services/utils.service'

@Injectable({
	providedIn: 'root',
})
export class UserHelperService {
	protected readonly json: JSON = JSON
	protected readonly deviceIdLocalStorageKeyConst: string = DeviceIdLocalStorageKeyConst

	public userDetail$: BehaviorSubject<UserDetailInterface | null> = new BehaviorSubject<UserDetailInterface | null>(
		null,
	)
	public toggleIsLimitedModal$: Subject<void> = new Subject<void>()
	public isSecret$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
	public isLoadingUserDetail$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	public isWorkingUserSocket: boolean = false

	private readonly _utilsService: UtilsService = inject<UtilsService>(UtilsService)

	get deviceId(): string | null {
		return this.json.parse(localStorage.getItem(this.deviceIdLocalStorageKeyConst) ?? 'null')
	}

	public generateDeviceId(): void {
		if (this.deviceId) return

		localStorage.setItem(
			this.deviceIdLocalStorageKeyConst,
			this.json.stringify(this._utilsService.generateUniqId()),
		)
	}

	public toggleWorkingUserSocket(value: boolean): void {
		this.isWorkingUserSocket = value
	}

	public dropUserData(): void {
		this.userDetail$.next(null)
	}

	public updateUserWebSettings(webSettings: WebSettingsInterface): void {
		const userDetail: UserDetailInterface | null = this.userDetail$.getValue()
		if (!userDetail) return
		this.userDetail$.next({
			...userDetail,
			web_settings: webSettings,
		})
	}

	public toggleSecret(): void {
		this.isSecret$.next(!this.isSecret$.getValue())
	}

	public checkIsLimited(): boolean {
		const isLimited: boolean = !!this.userDetail$.getValue()?.is_limited

		if (isLimited) {
			this.toggleIsLimitedModal$.next()
			return true
		}

		return false
	}
}
